/* eslint-disable react/prefer-es6-class */
/*
  Select component, this is a formsy select component that will automatically
  register to a formsy Form, validate and display errors.

  example use: <Select name="my_select_field" title="My Select"
                options=[{title='a', value: '1'}, {title='b', value: '2'}] />
*/
import React from 'react';
import Formsy from 'formsy-react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

export default createReactClass({
  mixins: [Formsy.Mixin],
  displayName: 'Select',

  propTypes: {
    options: PropTypes.array.isRequired,
    name: PropTypes.string,
    title: PropTypes.string,
    validationError: PropTypes.string,
  },

  componentDidMount() {
    this.setValue(this.props.setValue);
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.setValue && nextProps.setValue !== this.props.setValue) {
      this.setValue(nextProps.setValue);
    }
  },

  changeValue(event) {
    event.stopPropagation();
    this.setValue(event.currentTarget.value);
    if (this.props.changeValue) this.props.changeValue(event.currentTarget.value);
    if (this.props.onChange && event.type === 'change') {
      this.props.onChange(event);
    }
  },

  _getClassName() {
    return 'form-group ' +
           (this.props.className || '') +
           (this.isRequired() ? ' required' : '') +
           (this.showError() ? ' error' : '');
  },

  _getOptions() {
    //function accepted array of objects w. optgroups as keys
    return this.props.options.map((option) => {
      if (option.optgroup) {
        return this._renderOptGroup(option);
      }
      return this._renderOption(option);
    });
  },

  _renderOptGroup({ optgroup, options }) {
    return (
      <optgroup key={optgroup} label={optgroup}>
        {options.map((option) => this._renderOption(option))}
      </optgroup>
    );
  },

  _renderOption({ title, value }) {
    return <option key={title+value} value={value}>{title}</option>;
  },

  render() {
    return (
      <div className={this._getClassName()}>
        <label htmlFor={this.props.name}>{this.props.title}</label>
        <select name={this.props.name}
          aria-label={this.props.title || this.props.name}
          id={this.props.name}
          onChange={this.changeValue}
          value={this.getValue()}
        >
          {this._getOptions()}
        </select>
        <span className="validation-error">{this.getErrorMessage()}</span>
      </div>
    );
  },

});
